// eslint-disable-next-line import/no-cycle
import bffApi, {BffResponse} from '@client/bffApi';
import {AxiosResponse} from 'axios';
import {
  AccountActivityResponse,
  ClientOverviewResponse,
  ContactUsResponse,
  UserSummaryResponse,
} from './response/ServiceResponse';

export default {
  getOverviewData(userId: number): Promise<AxiosResponse<BffResponse<ClientOverviewResponse>>> {
    const url = `${bffApi.getBaseUrl(true)}/clients/${userId}/overview`;

    return bffApi.getAxiosInstance().get<BffResponse<ClientOverviewResponse>>(url);
  },
  getUserSummaryForUserId(userId: number): Promise<AxiosResponse<BffResponse<UserSummaryResponse>>> {
    return bffApi
      .getAxiosInstance()
      .get<BffResponse<UserSummaryResponse>>(`${bffApi.getBaseUrl(true)}/clients/${userId}/summary`);
  },
  getAccountActivityForUserId(userId: number): Promise<AxiosResponse<BffResponse<AccountActivityResponse>>> {
    return bffApi
      .getAxiosInstance()
      .get<BffResponse<AccountActivityResponse>>(`${bffApi.getBaseUrl(true)}/clients/${userId}/account-activity`);
  },
  getContactUsInfo(riaId, riaUserId): Promise<AxiosResponse<BffResponse<ContactUsResponse>>> {
    return bffApi
      .getAxiosInstance()
      .get<BffResponse<ContactUsResponse>>(`${bffApi.getBaseUrl(true)}/firm-profile/firms/${riaId}/ria-users/${riaUserId}`);
  },
};
